export default __webpack_public_path__ + "static/media/Path 87.f42c8f9f.svg";